module.exports = __webpack_public_path__ + "static/media/management-icon.95560270.svg";